import * as React from 'react';

export interface CenterProps {
  children?: React.ReactNode;
}

export default class Center extends React.PureComponent<CenterProps> {}
